module.exports = [
  'Hello.  What shall I do?',
  'add pension',
  'Is this a personal or a company pension?',
  'personal',
  'How much do you pay into it monthly?',
  '300',
  '£300. OK. Is this net or gross?',
  '400',
  '£400. OK. Is this net or gross?',
  'dunno',
  "Ok - I'll assume net for now.  How much is in the pension right now?",
  'about 60k',
  '£60,000.  OK. What is your birth date?',
];
